<template>
  <svg xmlns="http://www.w3.org/2000/svg" :viewBox="viewBox" class="svg-icon"
       focusable="false">
    <slot></slot>
  </svg>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'IconBase',
  props: {
    width: {
      type: Number as PropType<number>,
      required: true,
    },
    height: {
      type: Number as PropType<number>,
      required: true,
    },
  },
  setup(props) {
    const viewBox = computed(() => `0 0 ${props.width} ${props.height}`)
    const style = computed(() => ({ width: `${props.width / props.height}em` }))
    return {
      viewBox,
      style,
    }
  },
})
</script>

<style lang="stylus">
svg:not(:root).svg-icon
  overflow visible

  *
    fill currentColor

.svg-icon
  display inline-block
  font-size inherit
  height 1em
  overflow visible
  vertical-align -0.125em
</style>
